import getParam from './get-param';

export const assetUrl = 'https://storage.googleapis.com/planet-t2';
export const assetId = getParam('id');
